module.exports = __webpack_public_path__ + "img/addi.0d7c47a0.svg";